function spbcGetGoogleQrCode() {
	var data = {};
	var res = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_get_google_qr_code';

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			res = result;
		},
	});
	return res;
}

function spbcCheckGoogleCode() {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_check_google_code';
	data.code = jQuery('#spbct-google-qr-code input').val();

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				jQuery('#spbct-google-qr-code').dialog( "close" );
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

function spbcDisableG2fa( element ) {
	var data = {};
	data.security = spbcSettings.ajax_nonce;
	data.action = 'spbc_disable_google_2fa';
    data.user_id = jQuery(element).data('user-id');

	jQuery.ajax({
		type: "POST",
		async: false,
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(result.success) {
				document.location.reload();
			} else {
				alert(result.data);
			}
		},
	});
}

jQuery(document).ready(function(){
	
	// Auto update banner close handler 
	jQuery('.spbc_update_notice').on('click', 'button', function(){
		spbc_setCookie('spbc_update_banner_closed', 1, 86400 * 30);
	});

	// Enable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-enable', function(e){

		e.preventDefault();
		var spbcGoogleQrCode = spbcGetGoogleQrCode();

		if( spbcGoogleQrCode.success ) {
			var qr_code_div = jQuery('#spbct-google-qr-code-img');
			qr_code_div.html(spbcGoogleQrCode.data.img + '<p>' + spbcGoogleQrCode.data.code + '</p>');
			jQuery('#spbct-google-qr-code input').val('');
			jQuery('#spbct-google-qr-code').dialog({
				modal: true,
				title: 'Google authenticator activation',
				buttons: {
					Cancel: function() {
						jQuery( this ).dialog( "close" );
					},
					Ok: function() {
						spbcCheckGoogleCode();
					}
				},
				draggable: false,
				resizable: false,
			});
		} else {
			alert(spbcGetGoogleQrCode.data);
		}

	});

	// Disable G2FA from user profile page
	jQuery(document).on('click', '#spbc-g2fa-disable', function(e){

		e.preventDefault();
		if( confirm( 'Are you sure?' ) ) {
			spbcDisableG2fa( this );
		}

	});

	var refresh_user_online_counter = function( result, data, params ){
		setTimeout(function () {
			if( result !== null ){
				jQuery('.spbc-admin_bar--user_counter').html(result.count);
				if( result.count <= 3 ) {
					jQuery('#wp-admin-bar-spbc_admin_bar__online_users').show();
					jQuery('.spbc-admin_bar--online_users').html(result.users.join(', '));
				}else{
					jQuery('#wp-admin-bar-spbc_admin_bar__online_users').hide();
				}

			}
			spbc_sendAJAXRequest( data, params );
		}, 15000 );
	};

	if( +spbcSettings.admin_bar__users_online_counter === 1 ) {
		refresh_user_online_counter(null, {action: 'spbc_get_authorized_users'}, {callback: refresh_user_online_counter});
	}
});